import {Component} from 'react'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import TeamCard from '../TeamCard'
import './index.css'

class Home extends Component {
  state = {isLoading: true, teamsList: []}

  componentDidMount() {
    this.getTeamsList()
  }

  getTeamsList = async () => {
    const response = await fetch('https://apis.ccbp.in/ipl')
    const data = await response.json()
    const {teams} = data
    const updatedData = teams.map(eachItem => ({
      name: eachItem.name,
      id: eachItem.id,
      teamImageUrl: eachItem.team_image_url,
    }))

    this.setState({isLoading: false, teamsList: updatedData})
  }

  render() {
    const {isLoading, teamsList} = this.state

    return (
      <div className="home-container">
        <div className="body-container">
          <div className="app-name-container">
            <img
              className="app-logo"
              alt="ipl logo"
              src="https://assets.ccbp.in/frontend/react-js/ipl-logo-img.png"
            />
            <h1 className="app-name">IPL Dashboard</h1>
          </div>
          <ul className="team-cards-container">
            {isLoading ? (
              <div className="home-loader" testid="loader">
                <Loader type="Oval" color="#ffffff" height={50} width={50} />
              </div>
            ) : (
              teamsList.map(eachTeam => (
                <TeamCard key={eachTeam.id} details={eachTeam} />
              ))
            )}
          </ul>
        </div>
      </div>
    )
  }
}

export default Home
